import {
    Accordion,
    AccordionHeader,
    AccordionItem,
    AccordionPanel,
    Button,
    Text,
    makeStyles,
} from "@fluentui/react-components";
import { useTranslation } from "react-i18next";
import Status from "../../../enums/Status";
import MobileMainLink from "./MobileMainLink";
import { useMobileStyles } from "./MobileStyles";
import MobileArea from "./MobileArea";
import MobileLink from "./MobileLink";
import INavigationArea from "../../../models/navigation/INavigationArea";
import INavigationLink from "../../../models/navigation/INavigationLink";
import { NIL } from "uuid";

const useStyles = makeStyles({
    menu: {
        display: "flex",
		flexDirection: "column",
		gap: "1rem",
		alignItems: "flex-start",
		textAlign: "left"
    }
});

interface IMobileMenuProps {
    areas: INavigationArea[];
    status: Status;
    onNavigate: () => void;
}

export default function MobileMenu(props: IMobileMenuProps) {
    const { areas, status } = props;

    const { t } = useTranslation("navigation");
    const styles = useStyles();
    const mobileStyles = useMobileStyles();

    const aboutLinks: INavigationLink[] = [
        {
            title: t("ourStory.ourStory"),
            pageId: NIL,
            path: "ourstory"
        },
        {
            title: t("ourStory.partners"),
            pageId: NIL,
            path: "partners"
        },
        {
            title: t("ourStory.jobs"),
            pageId: NIL,
            path: "jobs"
        },
        {
            title: t("ourStory.sustainability"),
            pageId: NIL,
            path: "sustainability"
        }
    ];
    
    const portfolioLinks: INavigationLink[] = [
        {
            title: t("ourStory.caseStudies"),
            pageId: NIL,
            path: "casestudies"
        },
        {
            title: t("ourStory.testimonials"),
            pageId: NIL,
            path: "testimonials"
        },
        {
            title: t("ourStory.awards"),
            pageId: NIL,
            path: "awards"
        }
    ];

    return (
        <div className={styles.menu}>
            <MobileMainLink path="/" text={t("home")} onNavigate={props.onNavigate} />
            <Accordion collapsible className={mobileStyles.accordion}>
                <AccordionItem value="1">
                    <AccordionHeader as="div" expandIconPosition="end" className={mobileStyles.accordionHeader}>
                        <Button appearance="subtle" className={mobileStyles.button}>
                            {t("ourStory.ourStory")}
                        </Button>
                    </AccordionHeader>
                    <AccordionPanel>
                        <Text as="h3" block>
                            {t("ourStory.about")}
                        </Text>
                        {
                            aboutLinks.map((link, index) => <MobileLink key={index} link={link} onNavigate={props.onNavigate} />)
                        }

                        <Text as="h3" block>
                            {t("ourStory.portfolio")}
                        </Text>
                        {
                            portfolioLinks.map((link, index) => <MobileLink key={index} link={link} onNavigate={props.onNavigate} />)
                        }
                    </AccordionPanel>
                </AccordionItem>
                {
                    areas.map((area, index) => <MobileArea key={index} index={index + 2} area={area} onNavigate={props.onNavigate} />)
                }
            </Accordion>
            <MobileMainLink path="/blog" text={t("blog")} onNavigate={props.onNavigate} />
            <MobileMainLink path="/contact" text={t("contact")} onNavigate={props.onNavigate} />
        </div>
    );
};